import React from 'react';
import './style.scss';
import clsx from 'clsx';
import CreamCan from '../../../../../../assets/images/common/creamCan';

interface Props {
  bet: number;
  mode?: 'pc' | 'tablet' | 'mobile';
}

const BattleActionBet = ({ bet, mode = 'pc' }: Props) => {
  return (
    <div className={clsx('fight-action-bet-wrapper', `fabw-${mode}`)}>
      <h4 className='fight-action-bet-header body-2'>Big Hand:</h4>
      <div className='fight-action-bet'>
        {bet > 0 ? (
          <>
            <CreamCan className='fight-action-bet-image' />
            <div className='text'>{bet * 2}</div>
          </>
        ) : (
          <div className='text'>FREE</div>
        )}
      </div>
    </div>
  );
};

export default BattleActionBet;
